/**
 * Browser features the scanner needs to listen and score on the device. Every current desktop
 * Chrome, Firefox and Safari, and Safari on iOS 14.5 and later, has them all.
 */
export function missingFeatures({ microphone }: { microphone: boolean }): string[] {
  const missing: string[] = [];
  if (typeof AudioContext === 'undefined') missing.push('Web Audio');
  if (typeof AudioWorkletNode === 'undefined') missing.push('AudioWorklet');
  if (typeof WebAssembly === 'undefined') missing.push('WebAssembly');
  if (typeof Worker === 'undefined') missing.push('Web Workers');
  if (
    microphone &&
    typeof (navigator.mediaDevices as MediaDevices | undefined)?.getUserMedia !== 'function'
  )
    missing.push('microphone access (needs HTTPS)');
  return missing;
}
